import React, { useState, useEffect, useCallback, useRef } from 'react';
import sidekick from '@last-rev/contentful-sidekick-util';
import difference from 'lodash/difference';
import find from 'lodash/find';
import get from 'lodash/get';
import has from 'lodash/has';
import includes from 'lodash/includes';
import intersection from 'lodash/intersection';
import keys from 'lodash/keys';
import map from 'lodash/map';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import useTranslation from 'next-translate/useTranslation';
import cx from 'clsx';
import styles from './PageCourse.module.scss';
import Asset from '../Asset';
import ElementLink from '../ElementLink';
import useCourseImage from '../../utils/useCourseImage';
import getThemeClass from '../../utils/getThemeClass';
import useTopicDetails from '../../utils/useTopicDetails';
import PageCoursePropTypes from './PageCoursePropTypes';
import TopicLink from '../TopicLink';
import CourseFinishedPopup from '../CourseFinishedPopup';
import { setViewedCompletiondMessageForCourse, completeCourse } from '../../redux/modules/courses';
import Breadcrumb from '../Breadcrumb';
import { useRouter } from 'next/router';

const mapStateToProps = (state) => ({
  completedCourseTopics: state.courses.completedCourseTopics,
  completedCourses: state.courses.completed,
  completedCoursesLoaded: state.courses.loaded,
  completedCourseTopicsLoaded: state.courses.loadedCourseTopics,
  isLoggedIn: !!state.user.id
});

const mapDispatchToProps = {
  markCompletionMessageShown: setViewedCompletiondMessageForCourse,
  markCourseAsCompleted: completeCourse
};

function PageCourse({
  _id,
  _href,
  _as,
  _contentTypeId,
  // slug,
  name,
  category,
  image,
  thumbnail,
  description,
  objectives,
  // expectations,
  topics,
  courseCompleteCta,
  courseCompleteHeaderText,
  courseCompleteBody,
  courseCompleteImage,
  // redux state below
  completedCourseTopics,
  completedCourses,
  completedCoursesLoaded,
  completedCourseTopicsLoaded,
  // isLoggedIn,
  // redux actions below
  markCompletionMessageShown,
  markCourseAsCompleted,
  breadcrumbs

}) {
  const [nextTopic, setNextTopic] = useState(null);
  const [courseStartCtaTextKey, setCourseStartCtaTextKey] = useState('common:textStartCourse');
  const [showNextTopicLink, setShowNextTopicLink] = useState(true);
  const [courseHasBeenMarkedCompleted, setCourseHasBeenMarkedCompleted] = useState(false);
  const [completedTopicIds, setCompletedTopicIds] = useState([]);
  const [totalTime, setTotalTime] = useState(0)

  const router = useRouter()

  useEffect(() => {
    if (topics?.length && completedCourseTopicsLoaded) {
      const courseTopicIds = map(topics, '_id') || [];
      const completedIds = intersection(keys(get(completedCourseTopics, _id, {})), courseTopicIds);
      setCompletedTopicIds(completedIds);
      const completedLength = completedIds?.length;
      const percent = Math.round(100 * (completedLength / topics?.length));
      if (percent > 0) {
        setCourseStartCtaTextKey('common:continue');
      }

      const topic = find(topics, ({ _id: topicId }) => !includes(completedIds, topicId));
      if (topic) {
        setNextTopic(topic);
      }
    }
  }, [_id, topics, completedCourseTopicsLoaded, completedCourseTopics]);

  useEffect(() => {
    if (
      !courseHasBeenMarkedCompleted &&
      completedCoursesLoaded &&
      !has(completedCourses, _id) &&
      has(completedCourseTopics, _id)
    ) {
      const completedIds = keys(get(completedCourseTopics, _id));
      const allTopicIds = map(topics, '_id');
      if (difference(allTopicIds, completedIds)?.length === 0) {
        markCourseAsCompleted(_id);
        setCourseHasBeenMarkedCompleted(true);
      }
    }
  }, [
    _id,
    topics,
    completedCoursesLoaded,
    courseHasBeenMarkedCompleted,
    completedCourseTopics,
    completedCourses,
    markCourseAsCompleted
  ]);
  useEffect(() => {
    let count = 0
    topics && topics.map((topic, key) => {
      return count = count + topic?.readingTime


    })
    setTotalTime(count)
  }, [])
  const { t } = useTranslation();

  const courseStartCtaText = t(courseStartCtaTextKey);

  const { courseImage, assetParentContentTypeId, assetParentFieldName } = useCourseImage(
    _id,
    thumbnail || image,
    category
  );
  const progress = Math.round((completedTopicIds?.length / topics?.length) * 100);


  return (
    <div data-testid="PageCourse" className={styles.pageCourseWrap} {...sidekick(_id, null, null, 'Page - Course')}>
      <Breadcrumb breadcrumbs={breadcrumbs} />
      <section
        className={cx(styles.heroSection, 'themeBgColor', `theme-${getThemeClass({ _contentTypeId, category })}`)}>
        <div className={styles.heroContainer}>
          <div className={styles.heroRow}>

            <div className={styles.heroContentCol}>
              <div className={styles.totalWrapContainer}>
                <div className={styles.heroNameCol}>
                  <h1 data-testid="PageCourse-name" className={styles.heroName} {...sidekick(_id, 'name')}>
                    {name}
                  </h1>
                  <div className={styles.heroDescriptionCol}>
                    <div className={styles.heroDescriptionWrap} {...sidekick(_id, 'description')}>
                      <p className={styles.heroDescription} data-testid="PageCourse-objectives">
                        {objectives}
                      </p>
                    </div>

                  </div>
                  {(router.asPath.split("?")[0] !== "/") ?
                    completedTopicIds?.length ? (
                      <div className={styles.moduleContainerWrap}>
                        <div className={styles.progressBar}>
                          <div
                            className={styles.progressFill}
                            style={{ width: `${progress}%` }}
                          >
                          </div>

                        </div>
                        <span>{progress}%</span>
                      </div>
                    ) : null
                    : null}
                </div>
                {!(progress === 100) && showNextTopicLink && topics?.length ? (
                  <div className={styles.heroCtaWrap} data-testid="PageCourse-LinkWrap">
                    <TopicLink
                      linkText={courseStartCtaText}
                      topic={nextTopic || topics[0]}
                      courseHref={_href}
                      courseAs={_as}
                      className={styles.heroCta}
                    />
                  </div>
                ) : null}

              </div>

            </div>
            {courseImage ? (
              <div className={styles.heroImageCol} data-testid="PageCourse-image">
                <Asset
                  _id={assetParentContentTypeId}
                  /* eslint-disable-next-line react/jsx-props-no-spreading */
                  {...courseImage}
                  fieldName={assetParentFieldName}
                  height={220}
                  parentClass="pageCourse"
                  imageWrapClassName="imageCircle"
                />
              </div>
            ) : null}
          </div>
        </div>
      </section>

      <section className={styles.contentSection}>
        <div className={styles.contentContainer}>
          <div className={styles.contentRow}>
            <div className={styles.learningObjectivesCol}>
              <div className={styles.learningObjectivesWrap}>
                <div className={styles.modules}>

                  {topics?.length} {t('common:modules')}
                </div>
                <div className={styles.totalTime}>
                  {totalTime >= 60
                    ? `${Math.floor(totalTime / 60)} ${t('common:textHr')} ${totalTime % 60} ${t('common:textMin')}`
                    : `${totalTime} ${t('common:textMin')}`}
                </div>
              </div>
            </div>
          </div>
          <div className={` ${styles.tableOfContentsCol}`}>

            <div
              className={styles.tableOfContentsWrap}
              {...sidekick(_id, 'topics')}
              data-testid="PageCourse-tableOfContentsWrap">
              <ul className={styles.tableOfContents} data-testid="PageCourse-tableOfContentsTopics">
                {topics?.length
                  ? topics.map((topic, key) => {
                    const elementLinkClassName = includes(completedTopicIds, topic._id)
                      ? `${styles.topicName} ${styles.topicNameActive}`
                      : styles.topicName;
                    return (
                      <TopicLink
                        topic={topic}
                        courseHref={_href}
                        courseAs={_as}
                        className={elementLinkClassName}
                        key={key}
                      >
                        <li className={styles.circleICon} key={key}>
                          {completedTopicIds.includes(topic?._id) ?
                            (topics?.length === 1 ?
                              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="0.5" width="27" height="27" rx="13.5" fill="#1A1918" />
                                <rect x="0.5" y="0.5" width="27" height="27" rx="13.5" stroke="#1A1918" />
                                <path d="M8.58334 13.5835L12.3333 17.3335L19.2083 10.4585" stroke="white" strokeWidth="1.5" stroke-miterlimit="10" />
                              </svg>
                              :
                              key === 0 ? <svg width="28" height="60" viewBox="0 0 28 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="16.5" width="27" height="27" rx="13.5" fill="#1A1918" />
                                <rect x="0.5" y="16.5" width="27" height="27" rx="13.5" stroke="#1A1918" />
                                <path d="M8.58333 29.5835L12.3333 33.3335L19.2083 26.4585" stroke="white" strokeWidth="1.5" stroke-miterlimit="10" />
                                <rect x="13.75" y="44.25" width="0.5" height="15.5" fill="#BBB5AE" stroke="#BBB5AE" strokeWidth="0.5" />
                              </svg>
                                : key === topics?.length - 1 ? <svg width="28" height="60" viewBox="0 0 28 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <rect x="13.5" width="1" height="16" fill="#BBB5AE" />
                                  <rect x="0.5" y="16.5" width="27" height="27" rx="13.5" fill="#1A1918" />
                                  <rect x="0.5" y="16.5" width="27" height="27" rx="13.5" stroke="#1A1918" />
                                  <path d="M8.5835 29.5833L12.3335 33.3333L19.2085 26.4583" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />

                                </svg>
                                  :
                                  <svg width="28" height="60" viewBox="0 0 28 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="13.5" width="1" height="16" fill="#BBB5AE" />
                                    <rect x="0.5" y="16.5" width="27" height="27" rx="13.5" fill="#1A1918" />
                                    <rect x="0.5" y="16.5" width="27" height="27" rx="13.5" stroke="#1A1918" />
                                    <path d="M8.58333 29.5835L12.3333 33.3335L19.2083 26.4585" stroke="white" strokeWidth="1.5" stroke-miterlimit="10" />
                                    <rect x="13.5" y="44" width="1" height="16" fill="#BBB5AE" />
                                  </svg>
                            )


                            : (topics?.length === 1 ?
                              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="0.5" width="27" height="27" rx="13.5" stroke="#BBB5AE" />
                              </svg>
                              :
                              key === 0 ? <svg width="28" height="60" viewBox="0 0 28 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="16.5" width="27" height="27" rx="13.5" stroke="#BBB5AE" />
                                <rect x="13.75" y="44.25" width="0.5" height="15.5" fill="#BBB5AE" stroke="#BBB5AE" strokeWidth="0.5" />
                              </svg> : key === topics?.length - 1 ? <svg width="28" height="60" viewBox="0 0 28 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="13.5" width="1" height="16" fill="#BBB5AE" />
                                <rect x="0.5" y="16.5" width="27" height="27" rx="13.5" stroke="#BBB5AE" />
                              </svg>

                                :
                                <svg width="28" height="60" viewBox="0 0 28 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <rect x="13.5" width="1" height="16" fill="#BBB5AE" />
                                  <rect x="0.5" y="16.5" width="27" height="27" rx="13.5" stroke="#BBB5AE" />
                                  <rect x="13.5" y="44" width="1" height="16" fill="#BBB5AE" />
                                </svg>
                            )

                          }
                          <div>{topic.name}</div>
                        </li>
                      </TopicLink>
                    )
                  })
                  : null}

              </ul>


            </div>
          </div>
        </div>

      </section>


    </div>
  );
}
PageCourse.propTypes = {
  ...PageCoursePropTypes,
  // eslint-disable-next-line react/forbid-prop-types
  // isLoggedIn: PropTypes.bool
};

PageCourse.defaultProps = {
  isLoggedIn: false
};

export default connect(mapStateToProps, mapDispatchToProps)(PageCourse);
